export const PLAN = {
  ROOT: '/plan',
  PLACEMENTS: '/plan/placements',
  ENGINEERINGS: '/plan/egineerings',

  ALL_CHANGE_VERSIONS: '/plan/allChangeVersions',
  CHANGE_VERSION_DETAIL: '/plan/changeVersionDetail',
  DRAFT: '/plan/draft',
  DRAFT_ID: '/plan/draft/:id',
  EDIT: '/plan/edit',
  EDIT_ID: '/plan/edit/:id',
  NEW: '/plan/new',
  NEW_PLACEMENTS: '/plan/new/placements',
  NEW_ENGINEERING: '/plan/new/engineering',
  NEW_ENGINEERING_ID: '/plan/new/engineering/:id',
  OVP: '/plan/ovp',
  READONLY: '/plan/readonly',
  UPLOADING_PLAN_OVP: '/plan/uploadingPlanOVP',
};
